export const REMEMBER_WORKSPACE_MEMORY_NAME = "remember_workspace_memory";
export const REMEMBER_WORKSPACE_MEMORY_DESC = `Stores short-term workspace memory that may later be compacted into long-term memory for future AI conversations.

Use this proactively when the user reveals durable workspace-specific knowledge that is likely to matter again, even if they did not explicitly say "remember this".

Do not use this for:
- ephemeral task notes
- unconfirmed assistant inferences
- one-off discussion details that should stay only in the current chat
- secrets, credentials, or other sensitive values

Input:
- 'title' (required): Short label for the memory item.
- 'content' (required): Concise workspace fact, preference, glossary term, or instruction to reuse later.
- 'kind' (required): One of FACT | PREFERENCE | GLOSSARY | PLAYBOOK.
- 'memoryScopeIds' (required): Optional memory scopes this item is most relevant to. Use [] for general workspace memory.
- 'tags' (required): Short free-form tags for later filtering.

Returns:
- saved workspace memory item with id, title, kind, tier, memoryScopeIds, tags, source, status, and timestamps.`;
